import styled from "styled-components";

export const Container = styled.div`
  background-color: white;
  position: relative;
`;

export const ImgBanner = styled.img`
  @media only screen and (max-width: 769px) {
    display: flex;
    width: 100%;
  }
  width: 100vw;
  margin-top: -5px;
`;

export const Badge = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, ${(props) => props.locBadge});
  max-width: ${(props) => props.maxWidthM};
  max-height: ${(props) => props.maxHeightM};
  @media only screen and (min-width: 769px) {
    max-width: ${(props) => props.maxWidth};
    max-height: ${(props) => props.maxHeight};
  }
`;

export const ContainerHeadline = styled.div`
  // position: absolute;
  left: 0px;
  right: 0px;
  bottom: 32px;
`;

export const Headline = styled.h2`
  text-align: center;
  color: white;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0.08px;
  margin: 0;

  @media only screen and (min-width: 769px) {
    font-size: 28px;
    line-height: 40px;
  }
`;

export const SeriesHeadline = styled.p`
  font-family: Helvetica;
  font-size: 20px;
  font-style: italic;
  font-weight: 900;
  line-height: 15px;
  letter-spacing: 0px;
  text-align: center;
  text-shadow: #f45320 -1.5px 0.3px;
  color: rgba(255, 255, 255, 1);
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 4px auto 4px auto;
`;

export const HintScroll = styled.h2`
  font-size: 14px;
  color: #00bcf1;
  text-align: center;
  left: 50%;
  position: absolute;
  bottom: 0%;
  transform: translate(-50%, 30%);
  cursor: pointer;
`;

export const ScrollDownIcon = styled.img`
  @keyframes updown {
    0% {
      transform: translateY(-8%);
    }

    50% {
      transform: translateY(8%);
    }

    100% {
      transform: translateY(-8%);
    }
  }
  src: ${({ src }) => src ?? null};
  animation: updown 2s ease infinite;
  position: absolute;
  top: 0;
  bottom: 0%;
  left: 46%;
  transform: translate(-50%, -50%);
  cursor: pointer;
`;

export const TitleCity = styled.img`
  align-items: center;
  display: flex;
  justify-content: center;
  margin: 10px auto 4px auto;
  @media only screen and (min-width: 769px) {
    margin-top: 9vh;
    scale: 1.7;
  }
`;

export const TitleImg = styled.img`
  max-width: ${(props) => props?.maxWidth ?? "auto"};
  margin-top: ${(props) => props?.marginTop ?? "40px"};
  position: ${(props) => props?.position ?? "relative"};
  z-index: 2;
  transform: ${(props) => props?.scale ?? "none"};
  height: ${(props) => props?.height ?? "auto"};

  margin-left: auto;
  margin-right: auto;
`;

export const Box = styled.div`
  justify-content: center;
  display: flex;
  border-radius: 16px;
  background: linear-gradient(
    90deg,
    rgba(4, 195, 243, 0.56) 0%,
    rgba(28, 117, 188, 0.86) 49.95%,
    rgba(39, 43, 100, 0.81) 100%
  );
  text-align: center;
  white-space: pre;
  padding: 8px 20px;
  border: 2px solid #fff;
  @media only screen and (min-width: 769px) {
    padding: 20px;
  }
`;
